// Append-only activity log helpers — replaces src/lib/activity.js (Firebase version).
// RLS policy enforces no-update / no-delete at the database level.

import { supabase } from './supabase';

// ---------------------------------------------------------------------------
// logActivity — append one audit event for a lead.
// ---------------------------------------------------------------------------
export async function logActivity(leadId, action, { before = null, after = null, note = null } = {}) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not authenticated');

  const { error } = await supabase
    .from('activity')
    .insert({
      lead_id:     leadId,
      action,
      before_data: before ?? null,
      after_data:  after  ?? null,
      note:        note   ?? null,
      user_id:     user.id,
      user_name:   user.user_metadata?.display_name || user.email || ''
    });

  if (error) throw error;
}

// ---------------------------------------------------------------------------
// getActivity — recent activity for one lead, newest first.
// Returns entries in the same shape LeadDrawer expects from the Firebase version.
// ---------------------------------------------------------------------------
export async function getActivity(leadId, max = 50) {
  const { data, error } = await supabase
    .from('activity')
    .select('*')
    .eq('lead_id', leadId)
    .order('created_at', { ascending: false })
    .limit(max);

  if (error) throw error;

  return (data ?? []).map(r => ({
    id:       r.id,
    action:   r.action,
    before:   r.before_data,
    after:    r.after_data,
    note:     r.note,
    userId:   r.user_id,
    userName: r.user_name,
    // Shim: LeadDrawer calls a.at?.toDate?.() — this keeps that working.
    at: {
      toDate: () => new Date(r.created_at),
      _raw:   r.created_at
    }
  }));
}
